export default __webpack_public_path__ + "static/media/mapBackground.49093d45.jpg";